var map = {
	"./addaddress/addaddress.module": [
		"./src/app/addaddress/addaddress.module.ts",
		"addaddress-addaddress-module"
	],
	"./changpws/changpws.module": [
		"./src/app/changpws/changpws.module.ts",
		"changpws-changpws-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./editaddress/editaddress.module": [
		"./src/app/editaddress/editaddress.module.ts",
		"editaddress-editaddress-module"
	],
	"./filter/filter.module": [
		"./src/app/filter/filter.module.ts",
		"filter-filter-module"
	],
	"./filterproduct/filterproduct.module": [
		"./src/app/filterproduct/filterproduct.module.ts",
		"filterproduct-filterproduct-module"
	],
	"./location/location.module": [
		"./src/app/location/location.module.ts",
		"location-location-module"
	],
	"./makeupthankyou/makeupthankyou.module": [
		"./src/app/makeupthankyou/makeupthankyou.module.ts",
		"makeupthankyou-makeupthankyou-module"
	],
	"./makupdetails/makupdetails.module": [
		"./src/app/makupdetails/makupdetails.module.ts",
		"makupdetails-makupdetails-module"
	],
	"./manageaddress/manageaddress.module": [
		"./src/app/manageaddress/manageaddress.module.ts",
		"manageaddress-manageaddress-module"
	],
	"./mybooking/mybooking.module": [
		"./src/app/mybooking/mybooking.module.ts",
		"mybooking-mybooking-module"
	],
	"./paymentmethod/paymentmethod.module": [
		"./src/app/paymentmethod/paymentmethod.module.ts",
		"paymentmethod-paymentmethod-module"
	],
	"./policy/policy.module": [
		"./src/app/policy/policy.module.ts",
		"policy-policy-module"
	],
	"./productdetails/productdetails.module": [
		"./src/app/productdetails/productdetails.module.ts",
		"productdetails-productdetails-module"
	],
	"./productreview/productreview.module": [
		"./src/app/productreview/productreview.module.ts",
		"productreview-productreview-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./searchproduct/searchproduct.module": [
		"./src/app/searchproduct/searchproduct.module.ts",
		"searchproduct-searchproduct-module"
	],
	"./service-booking-address/service-booking-address.module": [
		"./src/app/service-booking-address/service-booking-address.module.ts",
		"service-booking-address-service-booking-address-module"
	],
	"./service-booking-datetime/service-booking-datetime.module": [
		"./src/app/service-booking-datetime/service-booking-datetime.module.ts",
		"service-booking-datetime-service-booking-datetime-module"
	],
	"./sort/sort.module": [
		"./src/app/sort/sort.module.ts",
		"sort-sort-module"
	],
	"./sortproduct/sortproduct.module": [
		"./src/app/sortproduct/sortproduct.module.ts",
		"sortproduct-sortproduct-module"
	],
	"./trams/trams.module": [
		"./src/app/trams/trams.module.ts",
		"trams-trams-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;